<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout wrap justify-center align-center class="text-xs-left view-price-calculator-container">
        <v-card>
          <v-card-title>
            Preisberechnung
            <v-spacer></v-spacer>
            <v-btn @click="refreshHotel()" color="primary">Preise Aktualisieren</v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-layout wrap fluid>
              <v-flex xs12 sm12 md7>
                <v-layout wrap>
                  <v-flex xs12 sm5 md5>
                    <v-menu
                      ref="menu1"
                      v-model="pickers.menu1"
                      :nudge-right="40"
                      scrollable
                      transition="scale-transition"
                      offset-y full-width
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          v-model="formatReadableArrivalDate"
                          label="Ankunft"
                          persistent-hint
                          prepend-icon="event"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="request.arrival"
                                     first-day-of-week="1" locale="de"
                                     scrollable no-title color="primary"
                                     @input="pickers.menu1 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm5 offset-sm2 md5 offset-md2>
                    <v-menu
                      ref="menu2"
                      v-model="pickers.menu2"
                      :nudge-right="40"
                      scrollable
                      transition="scale-transition"
                      offset-y full-width
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          v-model="formatReadableDepartureDate"
                          label="Abreise"
                          persistent-hint
                          prepend-icon="event"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="request.departure"
                                     first-day-of-week="1" locale="de"
                                     scrollable no-title color="primary"
                                     @input="pickers.menu2 = false"></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-layout wrap>
                      <v-flex xs12 class="text-sm-left">
                        <h3>Anzahl der Erwachsene: {{request.adults}}</h3>
                      </v-flex>

                      <v-flex xs12>
                        <v-slider
                          v-model="request.adults" min="0"
                          append-icon="add"
                          prepend-icon="remove"
                          @click:append="addAdults()"
                          @click:prepend="subtractAdults()"></v-slider>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-layout wrap>
                      <v-flex xs6 class="text-sm-left" style="padding-top: 10px;">
                        <h3>Anzahl der Kinder: {{countChildren()}}</h3>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn outlined color="primary" style="float: right;" @click="openChildrenDialog()">Kind hinzufügen</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4 offset-md1 v-if="request.children.length > 0">
                <h3>Hinzugefügte Kinder</h3>
                <v-data-table
                  :headers="headers"
                  :items="request.children" hide-default-footer>
                  <template v-slot:item="props">
                    <tr class="text-sm-left">
                      <td>{{ props.item.count }}</td>
                      <td>{{ props.item.age }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12>
                <v-btn color="primary" style="float: right;" @click="calculatePrices()">Preis berechnen</v-btn>
              </v-flex>
              <v-flex xs12 v-if="result !== undefined && result.success">
                <v-layout wrap row justify-center align-cente>
                  <v-flex xs12 sm12 md10 lg8 xl6>
                    <v-card>
                      <v-toolbar color="cyan" dark>
                        <v-icon>list</v-icon>

                        <v-toolbar-title>Ergebnisse nach Zimmer sortiert</v-toolbar-title>
                      </v-toolbar>
                      <v-alert :value="!result.success" type="error" outlined>
                        Preisberechnung konnte nicht durchgeführt werden!
                      </v-alert>
                      <h3 style="padding: 22px;" v-if="result.success">Anzahl der Nächte: {{ result.nights }}</h3>
                      <v-expansion-panels accordion>
                        <v-expansion-panel v-model="panel" expand v-for="(room, index) in result.rooms" :key="index + '_room'">
                          <v-expansion-panel-header>
                            <v-icon style="float: left;display: inline-block;" v-if="room.available" color="success">done</v-icon>
                            <v-icon style="float: left;display: inline-block;" color="error" v-else>close</v-icon>
                            <span style="font-size: 20px;margin-left: 15px;">{{room.name}} ({{room.externalId}})</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card flat>
                              <v-card-text>
                                <v-layout wrap v-if="!room.available">
                                  <v-alert value="true" outlined v-for="(hint, hintIndex) in room.hints" :key="hintIndex + '_hint'" type="info" style="width: 100%;margin-bottom: 20px;margin-top: 20px;">{{ hint }}</v-alert>
                                </v-layout>
                                <v-layout wrap v-else ml-2 class="text-sm-left">
                                  <v-flex xs12 mb-4 mt-4 v-for="(ratePlan, ratePlanIndex) in room.ratePlans" :key="ratePlanIndex + '_rateplan'">
                                    <h3 style="margin-bottom: 25px;"><v-icon color="primary">label</v-icon> {{ratePlan.name}} ({{ratePlan.ratePlanCode}})</h3>

                                    <v-layout wrap>
                                      <v-flex xs6 mb-2>
                                        <h3>Erwachsene:</h3>
                                      </v-flex>
                                      <v-flex xs6 mb-2 class="text-xs-right">
                                        <h3>{{ratePlan.adults | price}} € für die gesamte Aufenthalt</h3>
                                      </v-flex>

                                      <v-flex xs6 mb-2 v-if="ratePlan.count.additional > 0">
                                        <h3>Zusatzgäste:</h3>
                                      </v-flex>
                                      <v-flex xs6 mb-2 v-if="ratePlan.count.additional > 0" class="text-xs-right">
                                        <h3>
                                          {{ratePlan.additional.guests}} <span v-if="ratePlan.additional.guests > 1">Zusatzgäste</span><span v-else>Zusatzgast</span> für {{ratePlan.additional.price | price}} €
                                          <span v-if="ratePlan.additional.price > 0">
                                        pro Person, pro Tag
                                      </span>
                                        </h3>
                                      </v-flex>

                                      <v-flex xs6 mb-2 v-if="ratePlan.count.children > 0 && ratePlan.children.length > 0">
                                        <h3>Kinder:</h3>
                                      </v-flex>
                                      <v-flex xs6 mb-2 v-if="ratePlan.count.children > 0 && ratePlan.children.length > 0" class="text-xs-right">
                                        <v-layout wrap mb-2>
                                          <v-flex xs4>
                                            <h3>Anzahl</h3>
                                          </v-flex>
                                          <v-flex xs4>
                                            <h3>Alter</h3>
                                          </v-flex>
                                          <v-flex xs4 class="text-xs-right">
                                            <h3>Preis</h3>
                                          </v-flex>
                                        </v-layout>
                                        <v-layout wrap mb-2 v-for="(child, childIndex) in ratePlan.children" :key="childIndex + '_child'">
                                          <v-flex xs4>
                                            <h3>{{child.count}}</h3>
                                          </v-flex>
                                          <v-flex xs4>
                                            <h3>{{child.age}}</h3>
                                          </v-flex>
                                          <v-flex xs4 class="text-xs-right">
                                            <h3>{{child.price | price}} €</h3>
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>

                                      <v-flex xs12  v-if="ratePlan.count.children > 0 && ratePlan.children.length === 0">
                                        <v-alert value="true" outlined v-for="(hint, hintIndex) in ratePlan.hints" :key="hintIndex + '_rateplan_hint'" type="error" style="width: 100%;margin-bottom: 20px;margin-top: 20px;">{{ hint }}</v-alert>
                                      </v-flex>

                                      <v-flex xs6>
                                        <h2>Gesamt:</h2>
                                      </v-flex>
                                      <v-flex xs6>
                                        <h2 style="text-align: right;">{{ratePlan.total | price}} €</h2>
                                      </v-flex>
                                    </v-layout>

                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-else-if="result !== undefined && !result.success">
                <v-layout justify-center align-center wrap row v-for="(hint, index) in result.hints" mb-2 mt-2 :key="index + '_mainHint'">
                  <v-flex xs12 sm12 md8 lg6 xl5>
                    <v-alert
                      :value="true"
                      color="error"
                      icon="error"
                      outlined
                      transition="scale-transition">
                      {{hint}}
                    </v-alert>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-dialog
          v-model="child.dialog"
          hide-overlay
          persistent
          max-width="500px">
          <v-card>
            <v-card-title>
              <h4 style="margin-bottom: 30px">Kind hinzufügen</h4>
            </v-card-title>
            <v-card-text class="text-sm-left">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12 sm12 md5>
                    <v-text-field
                      v-model="child.count"
                      :rules="rules"
                      type="number"
                      required
                      label="Anzahl"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md5 offset-md2>
                    <v-text-field
                      v-model="child.age"
                      :rules="rules"
                      type="number"
                      required
                      label="Alter"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click.native="child.dialog = false">{{ $t('close') }}</v-btn>
              <v-btn color="primary" outlined @click.native="addChildren()">Hinzufügen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog.open"
          hide-overlay
          persistent
          width="300">
          <v-card
            color="primary"
            dark>
            <v-card-text>
              {{dialog.label}}
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
  import CalculatePrices from '../../mixins/CalculatePrices';
  export default {
    name: 'PriceCalculator',
    mixins: [CalculatePrices],
    data() {
      return {
        rates: [],
        hotel: undefined,
        width: 961,
        dialog: {
          open: false,
          label: 'Raten werden geladen'
        },
        request: {
          arrival: this.$moment().format('YYYY-MM-DD'),
          departure: this.$moment().add(1, 'days').format('YYYY-MM-DD'),
          adults: 2,
          children: []
        },
        pickers: {
          menu1: false,
          menu2: false
        },
        child: {
          count: undefined,
          age: undefined,
          dialog: false
        },
        rules: [
          v => !!v || this.$i18n.t('form.required')
        ],
        valid: undefined,
        headers: [
          { text: 'Anzahl', align: 'left', sortable: false },
          { text: 'Alter', align: 'left', sortable: false }
        ],
        result: undefined,
        panel: []
      };
    },
    mounted() {
      this.dialog.open = true;
      this.recalculateSize();
      this.fetchHotel(false);
    },
    methods: {
      refreshHotel() {
        this.dialog.label = 'Raten werden geladen';
        this.dialog.open = true;
        this.fetchHotel(true);
      },
      fetchHotel(refresh) {
        if (!refresh && this.$store.getters.hasHotel) {
          this.hotel = this.$store.getters.getHotel;
          this.hotel.kognitivHotelRooms.sort((a, b) => {
            return a.position - b.position;
          });
          this.fetchRates();
        } else {
          this.$http.get('hotels/own').then((data) => {
            this.hotel = data.body;
            this.hotel.kognitivHotelRooms.sort((a, b) => {
              return a.position - b.position;
            });
            this.$store.dispatch('setHotel', {hotel: this.hotel});
            this.fetchRates();
          });
        }
      },
      fetchRates() {
        this.$http.get('dynamic').then((data) => {
          for (let i = 0; i < this.hotel.kognitivHotelRooms.length; i += 1) {
            const room = this.hotel.kognitivHotelRooms[i];
            room.kognitivRatePlans.sort((a, b) => {
              return a.position - b.position;
            });
            for (let j = 0; j < room.kognitivRatePlans.length; j += 1) {
              const ratePlan = room.kognitivRatePlans[j];
              ratePlan.minStays.sort((a, b) => {
                return new Date(a.validUntil) - new Date(b.validUntil);
              });
              for (let k = 0; k < data.body.length; k += 1) {
                const dynamicRatePlan = data.body[k];
                if (ratePlan.ratePlan === dynamicRatePlan.ratePlanCode) {
                  ratePlan.dynamicDays = dynamicRatePlan.dynamicDays.sort((a, b) => {
                    return new Date(a.from) - new Date(b.from);
                  });
                  break;
                }
              }
            }
          }
          this.dialog.open = false;
          if (this.result !== undefined) {
            this.calculatePrices();
          }
        });
      },
      recalculateSize() {
        this.width = (window.innerWidth || document.documentElement.clientWidth
          || document.body.clientWidth);
      },
      isSmall() {
        return this.width < 960;
      },
      addAdults() {
        this.request.adults += 1;
      },
      subtractAdults() {
        this.request.adults -= 1;
      },
      openChildrenDialog() {
        this.child.dialog = true;
      },
      addChildren() {
        if (this.$refs.form.validate()) {
          const child = {
            age: Number(this.child.age),
            count: Number(this.child.count)
          };
          this.request.children.push(child);
          this.child.age = undefined;
          this.child.count = undefined;
          this.$refs.form.reset();
          this.child.dialog = false;
        }
      },
      countChildren() {
        let count = 0;
        for (let i = 0; i < this.request.children.length; i += 1) {
          const child = this.request.children[i];
          count += child.count;
        }
        return count;
      },
      calculatePrices() {
        this.dialog.label = 'Preise werden berechnet';
        this.dialog.open = true;
        const result = this.calculate(this.hotel, this.request);
        this.panel = [];
        for (let i = 0; i < result.rooms.length; i += 1) {
          if (i === 0) {
            this.panel.push(true);
          } else {
            this.panel.push(false);
          }
        }
        this.result = result;
        this.dialog.open = false;
      }
    },
    computed: {
      formatReadableArrivalDate() {
        return this.$moment(this.request.arrival).format('DD.MM.YYYY');
      },
      formatReadableDepartureDate() {
        return this.$moment(this.request.departure).format('DD.MM.YYYY');
      }
    },
  };
</script>

<style lang="scss">
  .view-price-calculator-container {
    table {
      tr {
        td {
          padding-top: 10px !important;
          padding-bottom: 10px !important;
        }
      }
    }
  }
</style>
